import { render, staticRenderFns } from "./OTPVerification.vue?vue&type=template&id=ebf0240c&scoped=true"
import script from "./OTPVerification.vue?vue&type=script&lang=js"
export * from "./OTPVerification.vue?vue&type=script&lang=js"
import style0 from "./OTPVerification.vue?vue&type=style&index=0&id=ebf0240c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf0240c",
  null
  
)

export default component.exports